import React  from 'react';
import kehujiaochexinxibiao from '../assets/img/kehujiaochexinxibiao.png';
import kucuncehmingxibiao from '../assets/img/kucuncehmingxibiao.png';
import yingshouzhangkuan from '../assets/img/yingshouzhangkuan.png';

const Enclosure630 = () => 
    <div
        style={{
            WebkitTouchCallout:'none',  /*系统默认菜单被禁用*/
            MozUserSelect: 'none',  /*火狐*/
            WebkitUserSelect: 'none',  /*webkit浏览器*/
            msUserSelect: 'none',  /*IE10*/
            khtmlUserSelect: 'none',  /*早期浏览器*/
            userSelect: 'none',
        }}
     >
        <div style={{ textIndent: '2em' }}>
        <h4>国产车接车检查单</h4>
        <img src={kehujiaochexinxibiao} alt="" style={{ width  : '90%', display: 'block', margin : '0 auto' }}/>
        <h4>国产车交车检查单</h4>
        <img src={kucuncehmingxibiao} alt="" style={{ width  : '90%', display: 'block', margin : '0 auto' }}/>
        <h4>《国产车信息汇总表（交车信息表、库存表、应收账款）》</h4>
        <img src={yingshouzhangkuan} alt="" style={{ width  : '90%', display: 'block', margin : '0 auto' }}/>
                        
            <br/><br/>
        </div>
    </div>


export default Enclosure630;